module.exports = __webpack_public_path__ + "static/media/FB_IMG_1486512865782.65bd0cc7.jpg";